<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>الحضور والانصراف اليومي</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="employers_attends"
        class="elevation-1"
        :loading="loading"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>
            <span
              v-if="props.item.attends.length > 0 && props.item.attends[0].come"
              >{{
                props.item.attends.length > 0 ? props.item.attends[0].come : ""
              }}</span
            >
            <v-btn
              v-else
              :disabled="
                props.item.attends.length > 0 &&
                  props.item.attends[0].come != null
              "
              color="orange"
              @click="add_come(props.item)"
              >حضور</v-btn
            >
          </td>
          <td>
            <span
              v-if="props.item.attends.length > 0 && props.item.attends[0].go"
              >{{
                props.item.attends.length > 0 ? props.item.attends[0].go : ""
              }}</span
            >
            <v-btn
              v-else
              color="red"
              :disabled="
                (props.item.attends.length > 0 &&
                  props.item.attends[0].go != null) ||
                  props.item.attends.length == 0
              "
              @click="add_go(props.item)"
              >انصراف</v-btn
            >
          </td>
          <td>
            {{
              props.item.attends.length > 0
                ? props.item.attends[0].working_hours
                : ""
            }}
          </td>
          <td
            :style="[
              props.item.attends.length > 0 &&
              props.item.attends[0].latency > '02:00'
                ? { 'background-color': 'red' }
                : props.item.attends.length > 0 &&
                  props.item.attends[0].latency > '01:00'
                ? { 'background-color': 'orange' }
                : props.item.attends.length > 0 &&
                  props.item.attends[0].latency > '00:00'
                ? { 'background-color': 'yellow' }
                : { 'background-color': 'white' }
            ]"
          >
            {{
              props.item.attends.length > 0 ? props.item.attends[0].latency : ""
            }}
          </td>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import { employers_attends, add_come, add_go } from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "الموظف",
        align: "right",
        sortable: false,
        value: "name"
      },
      { text: "حضور", value: "control", sortable: false, align: "center" },
      { text: "انصراف", value: "control", sortable: false, align: "center" },
      {
        text: "عدد ساعات العمل",
        value: "control",
        sortable: false,
        align: "center"
      },
      { text: "تأخير", value: "control", sortable: false, align: "center" }
    ],

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 20,
      descending: true
    },
    employers_attends: [],
    branchs: [],
    employers: [],
    mohafzas: [],
    cities: [],
    editedItem: {
      id: "",
      name: ""
    },
    newItem: {
      id: "",
      name: ""
    },
    menu1: false,
    time1: "",
    menu2: false,
    time2: ""
  }),

  computed: {
    // calculate_hourse() {
    // return function(time1, time2) {
    //   var t1 = time1.split(':');
    //   var t2 = time2.split(':');
    //   var h1 = t1[0],
    //     m1 = t1[1];
    //   var h2 = t2[0],
    //     m2 = t2[1];
    //     var h = 12 - parseInt(h1) + parseInt(h2);
    //     var m = parseInt(m1) - parseInt(m2);
    //     if(m > 59){ h++; m=m-60; }
    //     if(m < 0){ h--; m=m+60; }
    //  return h + ' ساعات ' + m + ' دقائق '
    // };
    // },
    calculate_latency() {
      // return function(time1, time2) {
      //   var t1 = time1.split(':');
      //   var t2 = time2.split(':');
      //   var h1 = t1[0],
      //     m1 = t1[1];
      //   var h2 = t2[0],
      //     m2 = t2[1];
      //     var h = parseInt(h1) - parseInt(h2);
      //     var m = parseInt(m1) - parseInt(m2);
      //     if(m > 59){ h++; m=m-60; }
      //     if(m < 0){ h--; m=m+60; }
      //  return h + ' ساعات ' + m + ' دقائق '
      // };
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      employers_attends().then(response => {
        this.employers_attends = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
      });
    },

    add_come(item) {
      var frmData = new FormData();
      frmData.append("employer_id", item.id);
      add_come(frmData).then(response => {
        this.$router.go(0);
        // console.log(response.data)
      });
    },
    add_go(item) {
      var frmData = new FormData();
      frmData.append("employer_id", item.id);
      frmData.append("attend_id", item.attends[0].id);
      add_go(frmData).then(response => {
        this.$router.go(0);
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
